export default __webpack_public_path__ + "static/media/salt1.a7dbaf5a.png";